import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { portalRoute } from "../_portal.js";

export const portalVaultRoute = createRoute({
  getParentRoute: () => portalRoute,
  path: "/portal/vault",
  component: lazyRouteComponent(() => import("./vault.page.js"), "PortalVaultPage"),
});
